import BackboneEvents from './backbone.events';
import type { Events } from 'backbone';

/**
 * Simple syntactic sugar for easier extending objects with events
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class Eventable {}
Object.assign(Eventable.prototype, BackboneEvents);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type,@typescript-eslint/no-unsafe-declaration-merging
interface Eventable extends Events {}

export default Eventable;
